export default __webpack_public_path__ + "static/media/logo.563b8a4a.png";